<template>
  <div class='content-viz'>
    <svg class='portada-red'>
    </svg>
  </div>
</template>

<script>
import * as d3 from 'd3';

export default {
  name: 'PortadaViz',
  data() {
    return {
      datos: {},
    };
  },
  mounted() {
    this.svg = d3.select('div.content-viz svg.portada-red');

    this.grupo_svg = this.svg
      .append('g')
      .attr('class', 'red');
    this.configurandoDimensionesSVG();
    d3.json('data/json_vis_sub.json')
      .then((data) => {
        let tiempo_fin_simulacion = Date.now() + 5500;
        this.datos = data;
        this.data_nodos = data.nodes;
        this.data_enlaces = data.links;
        this.data_nodos.forEach((d) => {
          d.x = d3.randomUniform(0,10)();
          d.y = d3.randomUniform(0,10)();
        })
        this.creandoEscalasColor();
        this.creandoEnlaces();
        this.creandoNodos();
        this.creandoSimulacion();
        this.simulacion.on('tick',() => this.actualizandoPosiciones(tiempo_fin_simulacion,this.simulacion));
      });
    window.addEventListener('resize', this.reescalandoPantalla);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.reescalandoPantalla);
  },
  computed:{
			vistaSimplificada() {
      return this.$store.getters.tieneVistaSimplificada;
    }},
  methods: {
    configurandoDimensionesSVG() {
      this.alto = document.querySelector('.content-viz').clientHeight;
      this.ancho = document.querySelector('.content-viz').clientWidth;
      this.svg.attr('width', this.ancho)
        .attr('height', this.alto);
      this.grupo_svg.attr('transform', `translate(${this.ancho / 2},${this.alto / 2})`);
      this.radio = 6;
    },
    creandoSimulacion() {
      this.simulacion = d3.forceSimulation(this.data_nodos)
        .force('link', d3.forceLink().id((d) => d.id).links(this.data_enlaces)
          .distance(50)
          .strength(1))
        .force('x', d3.forceX().x(0).strength((d) => (d.grado === 0 ? 0.008  : 0.001)))
        .force('y', d3.forceY().y(0).strength((d) => (d.grado === 0 ? 0.008 : 0.001)))
        .force('charge', d3.forceManyBody().strength(-4))
        .force('collision', d3.forceCollide().radius(this.radio + 3))
        .force('center', d3.forceCenter(0, 0));
    },
    creandoEscalasColor() {
      this.escalaCluster = d3.scaleQuantile()
        .domain(this.data_nodos.filter((d) => d.grado === 0).map((d) => d.cd4_a))
        .range(['#0695ff', '#4167ff', '#7c39ff', '#b70bff']);
      this.escalaIndependientes = d3.scaleQuantile()
        .domain(this.data_nodos.filter((d) => d.grado !== 0).map((d) => d.cd4_a))
        .range(['#f98c41', '#fb6230', '#fd371e', '#ff0d0d']);
    },
    creandoEnlaces() {
      this.svg_enlaces = this.grupo_svg
        .selectAll('ln')
        .data(this.data_enlaces)
        .enter()
        .append('line')
        .style('stroke', '#0695FF')
        .style('stroke-opacity', '.5')
        .style('stroke-width', '2px');
    },
    creandoNodos() {
      this.svg_nodos = this.grupo_svg
        .selectAll('crcl')
        .data(this.data_nodos)
        .enter()
        .append('g')

      this.svg_nodos.append('circle')
        .attr('r', this.radio)
        .style('fill', (d) => (d.grado === 0 ? this.escalaIndependientes(d.cd4_a) : this.escalaCluster(d.cd4_a)));
      this.svg_nodos.append('circle')
        .attr('r', this.radio + 3)
        .style('fill', 'none')
        //.style('stroke-width', (d) => (d.resistencia === 'Susceptible' ? '0' : `${0.5}px`))
        //.style('stroke', (d) => (d.cluster_id === 0 ? '#e85780' : '#8080eb'));
    },
    actualizandoPosiciones(tiempo, sim) {
      this.svg_enlaces
        .attr('x1', (d) => d.source.x)
        .attr('y1', (d) => d.source.y)
        .attr('x2', (d) => d.target.x)
        .attr('y2', (d) => d.target.y);
      this.svg_nodos
        .attr('transform', (d) => `translate(${d.x},${d.y})`);
  
    },
    reescalandoPantalla() {
      if(!this.vistaSimplificada){
        this.configurandoDimensionesSVG();
      }
    },
  },
};
</script>

<style scoped lang='scss'>
.content-viz{
  position: absolute;
  width: 100%;
  top: 0;
  height:100vh;
  background:#262324
}
</style>
